// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   Activity Log - Enterprise Corporate Design
   Matching GameManagement Theme
   ============================================ */

/* CSS Variables - Matching GameManagement Theme */
:root {
  --activity-log-bg: #f8f9fa;
  --activity-log-text: #000000;
  --activity-log-text-muted: #4a5568;
  --activity-log-border: rgba(135, 206, 235, 0.3);
  --light-sky-blue: #87ceeb;
  --light-red: #ff6b6b;
  --white: #ffffff;
  --navy-blue: #001f3f;
  --transition: all 0.2s ease;
}

/* ============================================
   Main Container
   ============================================ */
.ActivityLog_activityLog__m9KgF {
  min-height: calc(100vh - 60px);
  background: var(--activity-log-bg);
  padding: 1.5rem;
  color: var(--activity-log-text);
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}

/* ============================================
   Header
   ============================================ */
.ActivityLog_header__Qi1dA {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.ActivityLog_headerLeft__moy8B {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.ActivityLog_headerIcon__MtkYY {
  color: var(--light-sky-blue);
}

.ActivityLog_title__eqOfu {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--activity-log-text);
  margin: 0;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

/* ============================================
   Loading & Error States
   ============================================ */
.ActivityLog_loadingContainer__rsZ0x {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
}

.ActivityLog_spinner__vOS\\+v {
  color: var(--light-sky-blue);
  animation: ActivityLog_spin__uCXBa 1s linear infinite;
}

@keyframes ActivityLog_spin__uCXBa {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.ActivityLog_errorAlert__7Ud04 {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  background: var(--light-red);
  color: white;
  border-radius: 0.5rem;
  margin-bottom: 1.5rem;
  font-weight: 500;
}

.ActivityLog_errorAlert__7Ud04 svg {
  flex-shrink: 0;
}

/* ============================================
   Table Container
   ============================================ */
.ActivityLog_tableContainer__aG6hA {
  background: var(--white);
  border: 1px solid var(--activity-log-border);
  border-radius: 0.5rem;
  overflow-x: auto;
  overflow-y: visible;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.ActivityLog_table__U4SNo {
  width: 100%;
  border-collapse: collapse;
  min-width: 900px;
}

.ActivityLog_table__U4SNo thead {
  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);
  background-color: #000000;
  color: #ffffff;
}

.ActivityLog_table__U4SNo th {
  padding: 1rem;
  text-align: left;
  font-size: 0.875rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid rgba(255, 255, 255, 0.1);
  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);
  background-color: #000000;
  color: #ffffff;
  white-space: nowrap;
}

.ActivityLog_table__U4SNo tbody tr {
  border-bottom: 1px solid var(--activity-log-border);
  transition: var(--transition);
}

.ActivityLog_table__U4SNo tbody tr:hover {
  background: rgba(135, 206, 235, 0.05);
}

.ActivityLog_table__U4SNo tbody tr:last-child {
  border-bottom: none;
}

.ActivityLog_table__U4SNo td {
  padding: 1rem;
  font-size: 0.875rem;
  color: var(--activity-log-text);
  white-space: nowrap;
}

.ActivityLog_emptyState__\\+ikx1 {
  text-align: center;
  padding: 3rem 1rem;
  color: var(--activity-log-text-muted);
  font-style: italic;
}

/* ============================================
   Pagination
   ============================================ */
.ActivityLog_paginationContainer__5B\\+0p {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1.5rem;
  padding: 1rem;
  background: var(--white);
  border: 1px solid var(--activity-log-border);
  border-radius: 0.5rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.ActivityLog_paginationLeft__JJ2LU,
.ActivityLog_paginationRight__032Xf {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.ActivityLog_paginationCenter__fT87s {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  flex: 1 1;
  justify-content: center;
}

.ActivityLog_paginationButton__ddy4V {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  background: transparent;
  border: 1px solid var(--activity-log-border);
  border-radius: 0.375rem;
  color: var(--activity-log-text);
  cursor: pointer;
  transition: var(--transition);
}

.ActivityLog_paginationButton__ddy4V:hover:not(:disabled) {
  background: rgba(135, 206, 235, 0.1);
  border-color: var(--light-sky-blue);
  color: var(--light-sky-blue);
}

.ActivityLog_paginationButton__ddy4V:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.ActivityLog_paginationText__sobil {
  font-size: 0.875rem;
  color: var(--activity-log-text);
  white-space: nowrap;
}

.ActivityLog_paginationText__sobil strong {
  font-weight: 700;
  color: var(--light-sky-blue);
}

.ActivityLog_goToPageForm__YiwaL {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.ActivityLog_pageInput__87c2O {
  width: 60px;
  padding: 0.375rem 0.5rem;
  font-size: 0.875rem;
  border: 1px solid var(--activity-log-border);
  border-radius: 0.375rem;
  background: var(--white);
  color: var(--activity-log-text);
  transition: var(--transition);
  box-sizing: border-box;
}

.ActivityLog_pageInput__87c2O:focus {
  outline: none;
  border-color: var(--light-sky-blue);
  box-shadow: 0 0 0 3px rgba(135, 206, 235, 0.1);
}

.ActivityLog_goToPageButton__Kb9hS {
  padding: 0.375rem 0.75rem;
  background: var(--light-sky-blue);
  color: var(--white);
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
}

.ActivityLog_goToPageButton__Kb9hS:hover {
  background: #6bb6d4;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(135, 206, 235, 0.3);
}

.ActivityLog_goToPageButton__Kb9hS:active {
  transform: translateY(0);
}

.ActivityLog_pageSizeSelector__slswk {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.ActivityLog_pageSizeSelect__Vw\\+zp {
  padding: 0.375rem 0.5rem;
  font-size: 0.875rem;
  border: 1px solid var(--activity-log-border);
  border-radius: 0.375rem;
  background: var(--white);
  color: var(--activity-log-text);
  cursor: pointer;
  transition: var(--transition);
}

.ActivityLog_pageSizeSelect__Vw\\+zp:focus {
  outline: none;
  border-color: var(--light-sky-blue);
  box-shadow: 0 0 0 3px rgba(135, 206, 235, 0.1);
}

/* ============================================
   Tabs
   ============================================ */
.ActivityLog_tabBar__KM2i2 {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
  border-bottom: 2px solid var(--activity-log-border);
}

.ActivityLog_tab__Hh8Sq {
  padding: 0.5rem 1rem;
  background: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  margin-bottom: -2px;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--activity-log-text-muted);
  cursor: pointer;
  transition: var(--transition);
}

.ActivityLog_tab__Hh8Sq:hover {
  color: var(--navy-blue);
}

.ActivityLog_tabActive__K64-m {
  color: var(--navy-blue);
  border-bottom-color: var(--light-sky-blue);
}

/* ============================================
   Audit panel
   ============================================ */
.ActivityLog_auditPanel__Ytuzg {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.ActivityLog_auditFilters__T9\\+kO {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.75rem;
  padding: 0.75rem;
  background: var(--white);
  border: 1px solid var(--activity-log-border);
  border-radius: 0.5rem;
}

.ActivityLog_filterField__lOcM6 {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--activity-log-text-muted);
}

.ActivityLog_filterField__lOcM6 input,
.ActivityLog_filterField__lOcM6 select {
  min-width: 140px;
  padding: 0.375rem 0.5rem;
  font-size: 0.875rem;
  border: 1px solid var(--activity-log-border);
  border-radius: 0.375rem;
  background: var(--white);
  color: var(--activity-log-text);
}

.ActivityLog_filterField__lOcM6 input:focus,
.ActivityLog_filterField__lOcM6 select:focus {
  outline: none;
  border-color: var(--light-sky-blue);
  box-shadow: 0 0 0 3px rgba(135, 206, 235, 0.1);
}

.ActivityLog_filterActions__4c1qi {
  display: flex;
  gap: 0.5rem;
  margin-left: auto;
}

.ActivityLog_primaryButton__J0iWb,
.ActivityLog_secondaryButton__mu0Ya {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.4rem 0.875rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
}

.ActivityLog_primaryButton__J0iWb {
  background: var(--light-sky-blue);
  color: var(--white);
  border: none;
}

.ActivityLog_primaryButton__J0iWb:hover {
  background: #6bb6d4;
}

.ActivityLog_secondaryButton__mu0Ya {
  background: var(--white);
  color: var(--activity-log-text);
  border: 1px solid var(--activity-log-border);
}

.ActivityLog_secondaryButton__mu0Ya:hover:not(:disabled) {
  border-color: var(--light-sky-blue);
  color: var(--navy-blue);
}

.ActivityLog_secondaryButton__mu0Ya:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ActivityLog_auditTable__pWOnV td {
  white-space: normal;
  vertical-align: top;
}

.ActivityLog_auditRow__G-Ktd {
  cursor: pointer;
}

.ActivityLog_chevron__O34Hj,
.ActivityLog_chevronOpen__-yv6M {
  color: var(--activity-log-text-muted);
  transition: transform 0.2s ease;
}

.ActivityLog_chevronOpen__-yv6M {
  transform: rotate(180deg);
}

.ActivityLog_nowrap__JIjD9 {
  white-space: nowrap !important;
}

.ActivityLog_muted__uUScV {
  font-size: 0.75rem;
  color: var(--activity-log-text-muted);
}

.ActivityLog_actorName__t90gP {
  font-weight: 600;
}

.ActivityLog_categoryBadge__SIy20,
.ActivityLog_outcomeBadge__XLVdl {
  display: inline-block;
  padding: 0.125rem 0.5rem;
  margin-bottom: 0.25rem;
  border-radius: 999px;
  font-size: 0.6875rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: #edf2f7;
  color: #2d3748;
}

.ActivityLog_cat_player_risk__7wF0S { background: #fefcbf; color: #744210; }
.ActivityLog_cat_user_mgmt__n3IGE { background: #e9d8fd; color: #44337a; }
.ActivityLog_cat_balance__f-QGi { background: #c6f6d5; color: #22543d; }
.ActivityLog_cat_game__UmK0l { background: #bee3f8; color: #2a4365; }
.ActivityLog_cat_result__EUIrA { background: #fed7d7; color: #822727; }
.ActivityLog_cat_settings__49wgk { background: #feebc8; color: #7b341e; }
.ActivityLog_cat_privilege__8MgEd { background: #fed7e2; color: #702459; }
.ActivityLog_cat_auth__8VX3P { background: #e2e8f0; color: #1a202c; }
.ActivityLog_cat_security__Vp20d { background: #ff6b6b; color: #ffffff; }
.ActivityLog_cat_system__jaNor { background: #001f3f; color: #ffffff; }

.ActivityLog_outcome_success__2nfLh { background: #c6f6d5; color: #22543d; }
.ActivityLog_outcome_failed__hIEPX { background: #feebc8; color: #7b341e; }
.ActivityLog_outcome_denied__BX4rk { background: #fed7d7; color: #822727; }

.ActivityLog_changesCell__ncATf {
  min-width: 260px;
}

.ActivityLog_changeLine__u9AMS {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.375rem;
  font-size: 0.8125rem;
}

.ActivityLog_changeField__tm9bu {
  font-weight: 600;
  color: var(--navy-blue);
}

.ActivityLog_oldValue__5fK16 {
  color: #c53030;
  text-decoration: line-through;
  word-break: break-all;
}

.ActivityLog_newValue__utK1Q {
  color: #2f855a;
  font-weight: 600;
  word-break: break-all;
}

.ActivityLog_arrow__1uNwC {
  color: var(--activity-log-text-muted);
}

.ActivityLog_detailRow__948E\\+ {
  background: #f7fafc;
}

.ActivityLog_detailRow__948E\\+:hover {
  background: #f7fafc !important;
}

.ActivityLog_detailGrid__eQP3y {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.ActivityLog_detailLabel__DONL2 {
  font-size: 0.6875rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--activity-log-text-muted);
  margin-bottom: 0.25rem;
}

.ActivityLog_breakAll__WcuZ\\+ {
  word-break: break-all;
  font-size: 0.75rem;
}

.ActivityLog_errorText__A8ylH {
  color: #c53030;
}

.ActivityLog_changesTable__LLd-- {
  width: 100%;
  margin-bottom: 0.75rem;
  border-collapse: collapse;
  font-size: 0.8125rem;
}

.ActivityLog_changesTable__LLd-- th,
.ActivityLog_changesTable__LLd-- td {
  padding: 0.375rem 0.5rem;
  border: 1px solid var(--activity-log-border);
  text-align: left;
}

.ActivityLog_changesTable__LLd-- th {
  background: #edf2f7;
  font-weight: 700;
}

.ActivityLog_contextPre__TPVa2 {
  max-height: 320px;
  overflow: auto;
  margin: 0;
  padding: 0.75rem;
  background: #1a202c;
  color: #e2e8f0;
  border-radius: 0.375rem;
  font-size: 0.75rem;
  white-space: pre-wrap;
  word-break: break-all;
}

/* ============================================
   Responsive Design - Tablet
   ============================================ */
@media (max-width: 1024px) {
  .ActivityLog_activityLog__m9KgF {
    padding: 1.25rem;
  }

  .ActivityLog_title__eqOfu {
    font-size: 1.25rem;
  }

  .ActivityLog_table__U4SNo th,
  .ActivityLog_table__U4SNo td {
    padding: 0.875rem;
    font-size: 0.8125rem;
  }
}

/* ============================================
   Responsive Design - Mobile
   ============================================ */
@media (max-width: 768px) {
  .ActivityLog_activityLog__m9KgF {
    padding: 1rem;
  }

  .ActivityLog_header__Qi1dA {
    flex-direction: column;
    align-items: flex-start;
  }

  .ActivityLog_title__eqOfu {
    font-size: 1.125rem;
  }

  .ActivityLog_tableContainer__aG6hA {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .ActivityLog_table__U4SNo {
    min-width: 800px;
  }

  .ActivityLog_table__U4SNo th,
  .ActivityLog_table__U4SNo td {
    padding: 0.75rem 0.5rem;
    font-size: 0.75rem;
  }

  .ActivityLog_paginationContainer__5B\\+0p {
    flex-direction: column;
    align-items: stretch;
  }

  .ActivityLog_paginationCenter__fT87s {
    flex-direction: column;
    gap: 0.75rem;
  }

  .ActivityLog_paginationLeft__JJ2LU,
  .ActivityLog_paginationRight__032Xf {
    justify-content: center;
    width: 100%;
  }
}

/* ============================================
   Responsive Design - Small Mobile
   ============================================ */
@media (max-width: 480px) {
  .ActivityLog_activityLog__m9KgF {
    padding: 0.75rem;
  }

  .ActivityLog_title__eqOfu {
    font-size: 1rem;
  }

  .ActivityLog_table__U4SNo {
    min-width: 700px;
  }

  .ActivityLog_table__U4SNo th,
  .ActivityLog_table__U4SNo td {
    padding: 0.625rem 0.375rem;
    font-size: 0.6875rem;
  }

  .ActivityLog_paginationText__sobil {
    font-size: 0.75rem;
  }

  .ActivityLog_pageInput__87c2O {
    width: 50px;
    font-size: 0.75rem;
  }

  .ActivityLog_goToPageButton__Kb9hS {
    font-size: 0.75rem;
    padding: 0.25rem 0.5rem;
  }

  .ActivityLog_pageSizeSelect__Vw\\+zp {
    font-size: 0.75rem;
  }
}

/* ============================================
   Accessibility
   ============================================ */
@media (prefers-reduced-motion: reduce) {
  * {
    transition-duration: 0.01ms !important;
    animation-duration: 0.01ms !important;
  }
}

.ActivityLog_paginationButton__ddy4V:focus-visible,
.ActivityLog_pageInput__87c2O:focus-visible,
.ActivityLog_goToPageButton__Kb9hS:focus-visible,
.ActivityLog_pageSizeSelect__Vw\\+zp:focus-visible {
  outline: 2px solid var(--light-sky-blue);
  outline-offset: 2px;
}

`, "",{"version":3,"sources":["webpack://./src/styles/ActivityLog.module.css"],"names":[],"mappings":"AAAA;;;iDAGiD;;AAEjD,kDAAkD;AAClD;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,kCAAkC;EAClC,+CAA+C;EAC/C,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;;iDAEiD;AACjD;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,eAAe;EACf,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,SAAS;EACT,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,qDAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,4BAA4B;EAC5B,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;iDAEiD;AACjD;EACE,wBAAwB;EACxB,4CAA4C;EAC5C,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,0EAA0E;EAC1E,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,iDAAiD;EACjD,0EAA0E;EAC1E,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mDAAmD;EACnD,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,wBAAwB;EACxB,4CAA4C;EAC5C,qBAAqB;EACrB,eAAe;EACf,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,SAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,4CAA4C;EAC5C,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,4CAA4C;EAC5C,uBAAuB;EACvB,wBAAwB;EACxB,+BAA+B;EAC/B,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,4CAA4C;EAC5C,uBAAuB;EACvB,wBAAwB;EACxB,+BAA+B;EAC/B,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;;EAEE,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,4CAA4C;EAC5C,uBAAuB;EACvB,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;;EAEE,aAAa;EACb,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;EACnC,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sCAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,oCAAiB,mBAAmB,EAAE,cAAc,EAAE;AACtD,kCAAe,mBAAmB,EAAE,cAAc,EAAE;AACpD,+BAAY,mBAAmB,EAAE,cAAc,EAAE;AACjD,iCAAc,mBAAmB,EAAE,cAAc,EAAE;AACnD,mCAAgB,mBAAmB,EAAE,cAAc,EAAE;AACrD,oCAAiB,mBAAmB,EAAE,cAAc,EAAE;AACtD,+BAAY,mBAAmB,EAAE,cAAc,EAAE;AACjD,mCAAgB,mBAAmB,EAAE,cAAc,EAAE;AACrD,iCAAc,mBAAmB,EAAE,cAAc,EAAE;;AAEnD,sCAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,qCAAkB,mBAAmB,EAAE,cAAc,EAAE;AACvD,qCAAkB,mBAAmB,EAAE,cAAc,EAAE;;AAEvD;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;;EAEE,wBAAwB;EACxB,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;;iDAEiD;AACjD;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;IACjB,oBAAoB;EACtB;AACF;;AAEA;;iDAEiD;AACjD;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;;IAEE,uBAAuB;IACvB,WAAW;EACb;AACF;;AAEA;;iDAEiD;AACjD;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;;iDAEiD;AACjD;EACE;IACE,sCAAsC;IACtC,qCAAqC;EACvC;AACF;;AAEA;;;;EAIE,wCAAwC;EACxC,mBAAmB;AACrB","sourcesContent":["/* ============================================\n   Activity Log - Enterprise Corporate Design\n   Matching GameManagement Theme\n   ============================================ */\n\n/* CSS Variables - Matching GameManagement Theme */\n:root {\n  --activity-log-bg: #f8f9fa;\n  --activity-log-text: #000000;\n  --activity-log-text-muted: #4a5568;\n  --activity-log-border: rgba(135, 206, 235, 0.3);\n  --light-sky-blue: #87ceeb;\n  --light-red: #ff6b6b;\n  --white: #ffffff;\n  --navy-blue: #001f3f;\n  --transition: all 0.2s ease;\n}\n\n/* ============================================\n   Main Container\n   ============================================ */\n.activityLog {\n  min-height: calc(100vh - 60px);\n  background: var(--activity-log-bg);\n  padding: 1.5rem;\n  color: var(--activity-log-text);\n  width: 100%;\n  max-width: 100%;\n  overflow-x: hidden;\n  box-sizing: border-box;\n}\n\n/* ============================================\n   Header\n   ============================================ */\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.headerLeft {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.headerIcon {\n  color: var(--light-sky-blue);\n}\n\n.title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--activity-log-text);\n  margin: 0;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n}\n\n/* ============================================\n   Loading & Error States\n   ============================================ */\n.loadingContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n}\n\n.spinner {\n  color: var(--light-sky-blue);\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.errorAlert {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem;\n  background: var(--light-red);\n  color: white;\n  border-radius: 0.5rem;\n  margin-bottom: 1.5rem;\n  font-weight: 500;\n}\n\n.errorAlert svg {\n  flex-shrink: 0;\n}\n\n/* ============================================\n   Table Container\n   ============================================ */\n.tableContainer {\n  background: var(--white);\n  border: 1px solid var(--activity-log-border);\n  border-radius: 0.5rem;\n  overflow-x: auto;\n  overflow-y: visible;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 900px;\n}\n\n.table thead {\n  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);\n  background-color: #000000;\n  color: #ffffff;\n}\n\n.table th {\n  padding: 1rem;\n  text-align: left;\n  font-size: 0.875rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border-bottom: 2px solid rgba(255, 255, 255, 0.1);\n  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);\n  background-color: #000000;\n  color: #ffffff;\n  white-space: nowrap;\n}\n\n.table tbody tr {\n  border-bottom: 1px solid var(--activity-log-border);\n  transition: var(--transition);\n}\n\n.table tbody tr:hover {\n  background: rgba(135, 206, 235, 0.05);\n}\n\n.table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.table td {\n  padding: 1rem;\n  font-size: 0.875rem;\n  color: var(--activity-log-text);\n  white-space: nowrap;\n}\n\n.emptyState {\n  text-align: center;\n  padding: 3rem 1rem;\n  color: var(--activity-log-text-muted);\n  font-style: italic;\n}\n\n/* ============================================\n   Pagination\n   ============================================ */\n.paginationContainer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 1.5rem;\n  padding: 1rem;\n  background: var(--white);\n  border: 1px solid var(--activity-log-border);\n  border-radius: 0.5rem;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.paginationLeft,\n.paginationRight {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.paginationCenter {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n  flex: 1;\n  justify-content: center;\n}\n\n.paginationButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  background: transparent;\n  border: 1px solid var(--activity-log-border);\n  border-radius: 0.375rem;\n  color: var(--activity-log-text);\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.paginationButton:hover:not(:disabled) {\n  background: rgba(135, 206, 235, 0.1);\n  border-color: var(--light-sky-blue);\n  color: var(--light-sky-blue);\n}\n\n.paginationButton:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.paginationText {\n  font-size: 0.875rem;\n  color: var(--activity-log-text);\n  white-space: nowrap;\n}\n\n.paginationText strong {\n  font-weight: 700;\n  color: var(--light-sky-blue);\n}\n\n.goToPageForm {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.pageInput {\n  width: 60px;\n  padding: 0.375rem 0.5rem;\n  font-size: 0.875rem;\n  border: 1px solid var(--activity-log-border);\n  border-radius: 0.375rem;\n  background: var(--white);\n  color: var(--activity-log-text);\n  transition: var(--transition);\n  box-sizing: border-box;\n}\n\n.pageInput:focus {\n  outline: none;\n  border-color: var(--light-sky-blue);\n  box-shadow: 0 0 0 3px rgba(135, 206, 235, 0.1);\n}\n\n.goToPageButton {\n  padding: 0.375rem 0.75rem;\n  background: var(--light-sky-blue);\n  color: var(--white);\n  border: none;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.goToPageButton:hover {\n  background: #6bb6d4;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(135, 206, 235, 0.3);\n}\n\n.goToPageButton:active {\n  transform: translateY(0);\n}\n\n.pageSizeSelector {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.pageSizeSelect {\n  padding: 0.375rem 0.5rem;\n  font-size: 0.875rem;\n  border: 1px solid var(--activity-log-border);\n  border-radius: 0.375rem;\n  background: var(--white);\n  color: var(--activity-log-text);\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.pageSizeSelect:focus {\n  outline: none;\n  border-color: var(--light-sky-blue);\n  box-shadow: 0 0 0 3px rgba(135, 206, 235, 0.1);\n}\n\n/* ============================================\n   Tabs\n   ============================================ */\n.tabBar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n  border-bottom: 2px solid var(--activity-log-border);\n}\n\n.tab {\n  padding: 0.5rem 1rem;\n  background: transparent;\n  border: none;\n  border-bottom: 3px solid transparent;\n  margin-bottom: -2px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--activity-log-text-muted);\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.tab:hover {\n  color: var(--navy-blue);\n}\n\n.tabActive {\n  color: var(--navy-blue);\n  border-bottom-color: var(--light-sky-blue);\n}\n\n/* ============================================\n   Audit panel\n   ============================================ */\n.auditPanel {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.auditFilters {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 0.75rem;\n  padding: 0.75rem;\n  background: var(--white);\n  border: 1px solid var(--activity-log-border);\n  border-radius: 0.5rem;\n}\n\n.filterField {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--activity-log-text-muted);\n}\n\n.filterField input,\n.filterField select {\n  min-width: 140px;\n  padding: 0.375rem 0.5rem;\n  font-size: 0.875rem;\n  border: 1px solid var(--activity-log-border);\n  border-radius: 0.375rem;\n  background: var(--white);\n  color: var(--activity-log-text);\n}\n\n.filterField input:focus,\n.filterField select:focus {\n  outline: none;\n  border-color: var(--light-sky-blue);\n  box-shadow: 0 0 0 3px rgba(135, 206, 235, 0.1);\n}\n\n.filterActions {\n  display: flex;\n  gap: 0.5rem;\n  margin-left: auto;\n}\n\n.primaryButton,\n.secondaryButton {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.375rem;\n  padding: 0.4rem 0.875rem;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.primaryButton {\n  background: var(--light-sky-blue);\n  color: var(--white);\n  border: none;\n}\n\n.primaryButton:hover {\n  background: #6bb6d4;\n}\n\n.secondaryButton {\n  background: var(--white);\n  color: var(--activity-log-text);\n  border: 1px solid var(--activity-log-border);\n}\n\n.secondaryButton:hover:not(:disabled) {\n  border-color: var(--light-sky-blue);\n  color: var(--navy-blue);\n}\n\n.secondaryButton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.auditTable td {\n  white-space: normal;\n  vertical-align: top;\n}\n\n.auditRow {\n  cursor: pointer;\n}\n\n.chevron,\n.chevronOpen {\n  color: var(--activity-log-text-muted);\n  transition: transform 0.2s ease;\n}\n\n.chevronOpen {\n  transform: rotate(180deg);\n}\n\n.nowrap {\n  white-space: nowrap !important;\n}\n\n.muted {\n  font-size: 0.75rem;\n  color: var(--activity-log-text-muted);\n}\n\n.actorName {\n  font-weight: 600;\n}\n\n.categoryBadge,\n.outcomeBadge {\n  display: inline-block;\n  padding: 0.125rem 0.5rem;\n  margin-bottom: 0.25rem;\n  border-radius: 999px;\n  font-size: 0.6875rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  background: #edf2f7;\n  color: #2d3748;\n}\n\n.cat_player_risk { background: #fefcbf; color: #744210; }\n.cat_user_mgmt { background: #e9d8fd; color: #44337a; }\n.cat_balance { background: #c6f6d5; color: #22543d; }\n.cat_game { background: #bee3f8; color: #2a4365; }\n.cat_result { background: #fed7d7; color: #822727; }\n.cat_settings { background: #feebc8; color: #7b341e; }\n.cat_privilege { background: #fed7e2; color: #702459; }\n.cat_auth { background: #e2e8f0; color: #1a202c; }\n.cat_security { background: #ff6b6b; color: #ffffff; }\n.cat_system { background: #001f3f; color: #ffffff; }\n\n.outcome_success { background: #c6f6d5; color: #22543d; }\n.outcome_failed { background: #feebc8; color: #7b341e; }\n.outcome_denied { background: #fed7d7; color: #822727; }\n\n.changesCell {\n  min-width: 260px;\n}\n\n.changeLine {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 0.375rem;\n  font-size: 0.8125rem;\n}\n\n.changeField {\n  font-weight: 600;\n  color: var(--navy-blue);\n}\n\n.oldValue {\n  color: #c53030;\n  text-decoration: line-through;\n  word-break: break-all;\n}\n\n.newValue {\n  color: #2f855a;\n  font-weight: 600;\n  word-break: break-all;\n}\n\n.arrow {\n  color: var(--activity-log-text-muted);\n}\n\n.detailRow {\n  background: #f7fafc;\n}\n\n.detailRow:hover {\n  background: #f7fafc !important;\n}\n\n.detailGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n\n.detailLabel {\n  font-size: 0.6875rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--activity-log-text-muted);\n  margin-bottom: 0.25rem;\n}\n\n.breakAll {\n  word-break: break-all;\n  font-size: 0.75rem;\n}\n\n.errorText {\n  color: #c53030;\n}\n\n.changesTable {\n  width: 100%;\n  margin-bottom: 0.75rem;\n  border-collapse: collapse;\n  font-size: 0.8125rem;\n}\n\n.changesTable th,\n.changesTable td {\n  padding: 0.375rem 0.5rem;\n  border: 1px solid var(--activity-log-border);\n  text-align: left;\n}\n\n.changesTable th {\n  background: #edf2f7;\n  font-weight: 700;\n}\n\n.contextPre {\n  max-height: 320px;\n  overflow: auto;\n  margin: 0;\n  padding: 0.75rem;\n  background: #1a202c;\n  color: #e2e8f0;\n  border-radius: 0.375rem;\n  font-size: 0.75rem;\n  white-space: pre-wrap;\n  word-break: break-all;\n}\n\n/* ============================================\n   Responsive Design - Tablet\n   ============================================ */\n@media (max-width: 1024px) {\n  .activityLog {\n    padding: 1.25rem;\n  }\n\n  .title {\n    font-size: 1.25rem;\n  }\n\n  .table th,\n  .table td {\n    padding: 0.875rem;\n    font-size: 0.8125rem;\n  }\n}\n\n/* ============================================\n   Responsive Design - Mobile\n   ============================================ */\n@media (max-width: 768px) {\n  .activityLog {\n    padding: 1rem;\n  }\n\n  .header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .title {\n    font-size: 1.125rem;\n  }\n\n  .tableContainer {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .table {\n    min-width: 800px;\n  }\n\n  .table th,\n  .table td {\n    padding: 0.75rem 0.5rem;\n    font-size: 0.75rem;\n  }\n\n  .paginationContainer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .paginationCenter {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .paginationLeft,\n  .paginationRight {\n    justify-content: center;\n    width: 100%;\n  }\n}\n\n/* ============================================\n   Responsive Design - Small Mobile\n   ============================================ */\n@media (max-width: 480px) {\n  .activityLog {\n    padding: 0.75rem;\n  }\n\n  .title {\n    font-size: 1rem;\n  }\n\n  .table {\n    min-width: 700px;\n  }\n\n  .table th,\n  .table td {\n    padding: 0.625rem 0.375rem;\n    font-size: 0.6875rem;\n  }\n\n  .paginationText {\n    font-size: 0.75rem;\n  }\n\n  .pageInput {\n    width: 50px;\n    font-size: 0.75rem;\n  }\n\n  .goToPageButton {\n    font-size: 0.75rem;\n    padding: 0.25rem 0.5rem;\n  }\n\n  .pageSizeSelect {\n    font-size: 0.75rem;\n  }\n}\n\n/* ============================================\n   Accessibility\n   ============================================ */\n@media (prefers-reduced-motion: reduce) {\n  * {\n    transition-duration: 0.01ms !important;\n    animation-duration: 0.01ms !important;\n  }\n}\n\n.paginationButton:focus-visible,\n.pageInput:focus-visible,\n.goToPageButton:focus-visible,\n.pageSizeSelect:focus-visible {\n  outline: 2px solid var(--light-sky-blue);\n  outline-offset: 2px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"activityLog": `ActivityLog_activityLog__m9KgF`,
	"header": `ActivityLog_header__Qi1dA`,
	"headerLeft": `ActivityLog_headerLeft__moy8B`,
	"headerIcon": `ActivityLog_headerIcon__MtkYY`,
	"title": `ActivityLog_title__eqOfu`,
	"loadingContainer": `ActivityLog_loadingContainer__rsZ0x`,
	"spinner": `ActivityLog_spinner__vOS+v`,
	"spin": `ActivityLog_spin__uCXBa`,
	"errorAlert": `ActivityLog_errorAlert__7Ud04`,
	"tableContainer": `ActivityLog_tableContainer__aG6hA`,
	"table": `ActivityLog_table__U4SNo`,
	"emptyState": `ActivityLog_emptyState__+ikx1`,
	"paginationContainer": `ActivityLog_paginationContainer__5B+0p`,
	"paginationLeft": `ActivityLog_paginationLeft__JJ2LU`,
	"paginationRight": `ActivityLog_paginationRight__032Xf`,
	"paginationCenter": `ActivityLog_paginationCenter__fT87s`,
	"paginationButton": `ActivityLog_paginationButton__ddy4V`,
	"paginationText": `ActivityLog_paginationText__sobil`,
	"goToPageForm": `ActivityLog_goToPageForm__YiwaL`,
	"pageInput": `ActivityLog_pageInput__87c2O`,
	"goToPageButton": `ActivityLog_goToPageButton__Kb9hS`,
	"pageSizeSelector": `ActivityLog_pageSizeSelector__slswk`,
	"pageSizeSelect": `ActivityLog_pageSizeSelect__Vw+zp`,
	"tabBar": `ActivityLog_tabBar__KM2i2`,
	"tab": `ActivityLog_tab__Hh8Sq`,
	"tabActive": `ActivityLog_tabActive__K64-m`,
	"auditPanel": `ActivityLog_auditPanel__Ytuzg`,
	"auditFilters": `ActivityLog_auditFilters__T9+kO`,
	"filterField": `ActivityLog_filterField__lOcM6`,
	"filterActions": `ActivityLog_filterActions__4c1qi`,
	"primaryButton": `ActivityLog_primaryButton__J0iWb`,
	"secondaryButton": `ActivityLog_secondaryButton__mu0Ya`,
	"auditTable": `ActivityLog_auditTable__pWOnV`,
	"auditRow": `ActivityLog_auditRow__G-Ktd`,
	"chevron": `ActivityLog_chevron__O34Hj`,
	"chevronOpen": `ActivityLog_chevronOpen__-yv6M`,
	"nowrap": `ActivityLog_nowrap__JIjD9`,
	"muted": `ActivityLog_muted__uUScV`,
	"actorName": `ActivityLog_actorName__t90gP`,
	"categoryBadge": `ActivityLog_categoryBadge__SIy20`,
	"outcomeBadge": `ActivityLog_outcomeBadge__XLVdl`,
	"cat_player_risk": `ActivityLog_cat_player_risk__7wF0S`,
	"cat_user_mgmt": `ActivityLog_cat_user_mgmt__n3IGE`,
	"cat_balance": `ActivityLog_cat_balance__f-QGi`,
	"cat_game": `ActivityLog_cat_game__UmK0l`,
	"cat_result": `ActivityLog_cat_result__EUIrA`,
	"cat_settings": `ActivityLog_cat_settings__49wgk`,
	"cat_privilege": `ActivityLog_cat_privilege__8MgEd`,
	"cat_auth": `ActivityLog_cat_auth__8VX3P`,
	"cat_security": `ActivityLog_cat_security__Vp20d`,
	"cat_system": `ActivityLog_cat_system__jaNor`,
	"outcome_success": `ActivityLog_outcome_success__2nfLh`,
	"outcome_failed": `ActivityLog_outcome_failed__hIEPX`,
	"outcome_denied": `ActivityLog_outcome_denied__BX4rk`,
	"changesCell": `ActivityLog_changesCell__ncATf`,
	"changeLine": `ActivityLog_changeLine__u9AMS`,
	"changeField": `ActivityLog_changeField__tm9bu`,
	"oldValue": `ActivityLog_oldValue__5fK16`,
	"newValue": `ActivityLog_newValue__utK1Q`,
	"arrow": `ActivityLog_arrow__1uNwC`,
	"detailRow": `ActivityLog_detailRow__948E+`,
	"detailGrid": `ActivityLog_detailGrid__eQP3y`,
	"detailLabel": `ActivityLog_detailLabel__DONL2`,
	"breakAll": `ActivityLog_breakAll__WcuZ+`,
	"errorText": `ActivityLog_errorText__A8ylH`,
	"changesTable": `ActivityLog_changesTable__LLd--`,
	"contextPre": `ActivityLog_contextPre__TPVa2`
};
export default ___CSS_LOADER_EXPORT___;
